import React from 'react';
import Typography from '@mui/material/Typography';

export default function PrimaryHeading(props) {
  return (
    <Typography
      className={props.className || 'primary-heading'}
      variant={props.variant || 'h2'}
      sx={{
        fontFamily: 'Lato, sans-serif',
        fontSize: '28px',
        fontWeight: '700',
        lineHeight: '33.6px',
        textAlign: 'left',
        color: '#000000',
        ...props.sx,
      }}
    >
      {props.children}
    </Typography>
  );
}
